
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universul-lego",
      function () {
        return require("private-next-pages/universul-lego.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/universul-lego"])
      });
    }
  